import { isAxiosError } from 'axios'
import { SignedUrlOssUploadError } from '@/shared/lib/reportSignedUrlOssUploadFailure'
import { isUploadTooLargeError } from '@/shared/lib/uploadGuardrails'

const SHIPMENT_SKU_FILE_UNREADABLE_MESSAGE =
  'Could not read that file. Upload an Excel (.xls or .xlsx) or CSV file.'

export function skuFileErrorMessage(
  error: unknown,
  translate: (key: string) => string
): string {
  if (error instanceof SignedUrlOssUploadError) {
    return translate('shipmentsPage.skuFile.unreadable')
  }
  if (isUploadTooLargeError(error)) {
    return translate('shipmentsPage.skuFile.tooLarge')
  }
  let serverMessage: string | null = null
  if (
    isAxiosError(error) &&
    typeof error.response?.data?.message === 'string'
  ) {
    serverMessage = error.response.data.message
  }
  if (serverMessage === SHIPMENT_SKU_FILE_UNREADABLE_MESSAGE) {
    return translate('shipmentsPage.skuFile.unreadable')
  }
  if (serverMessage === 'That file has no SKU rows.') {
    return translate('shipmentsPage.skuFile.noRows')
  }
  if (serverMessage === 'File exceeds the maximum upload size of 30 MB') {
    return translate('shipmentsPage.skuFile.tooLarge')
  }
  if (serverMessage === 'Workbook exceeds the maximum of 50000 SKU rows') {
    return translate('shipmentsPage.skuFile.tooManySourceRows')
  }
  if (serverMessage === 'Workbook has more than 10000 unique SKUs') {
    return translate('shipmentsPage.skuFile.tooManyUniqueSkus')
  }
  if (serverMessage === 'Workbook exceeds the maximum of 100 columns') {
    return translate('shipmentsPage.skuFile.tooManyColumns')
  }
  if (
    serverMessage ===
    'Excel 97-2003 (.xls) files must be 10 MB or smaller. Save as .xlsx or CSV.'
  ) {
    return translate('shipmentsPage.skuFile.xlsTooLarge')
  }
  if (
    serverMessage ===
    'That workbook is too large to read. Upload the first sheet only, or a CSV.'
  ) {
    return translate('shipmentsPage.skuFile.workbookTooLarge')
  }
  if (
    serverMessage ===
    'That workbook has too much text to read. Upload a CSV.'
  ) {
    return translate('shipmentsPage.skuFile.workbookTooMuchText')
  }
  return translate('shipmentsPage.skuFile.unreadable')
}
